import { documentQualityMetrics } from "@/mocks/documentos";

export default function DocumentQualityPanel() {
  return (
    <div className="bg-white rounded-xl border border-background-200/70 p-4 md:p-5">
      <h3 className="text-sm font-semibold text-foreground-900 mb-4">Qualidade Documental</h3>
      <div className="space-y-4">
        {documentQualityMetrics.map((m) => (
          <div key={m.label}>
            <div className="flex justify-between text-xs mb-1.5">
              <span className="text-foreground-600">{m.label}</span>
              <span className={`font-semibold ${m.status === "bom" ? "text-primary-600" : m.status === "regular" ? "text-caution-600" : "text-danger-600"}`}>
                {m.value}{m.unit}
                <span className="text-foreground-400 font-normal ml-1">/ meta {m.target}{m.unit}</span>
              </span>
            </div>
            <div className="w-full bg-background-200 rounded-full h-2.5">
              <div
                className={`h-2.5 rounded-full transition-all ${
                  m.status === "bom" ? "bg-primary-500" : m.status === "regular" ? "bg-caution-500" : "bg-danger-500"
                }`}
                style={{ width: `${Math.min(m.value, 100)}%` }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}